export const CARD_TYPES = {
  BASE_CARD: 'base_card', //text only card without any special styles (borders, images, etc) can be styled as a part of a list
  BLOG_POST_CARD: 'content_post', // Image? and text card with yellow border top
  PERSON_WITH_IMAGE: 'person_with_image', // Rounded image and text card
  SIMPLE_BOX_CARD: 'simple_box_card', // Simple text card with colors
  SIMPLE_PRESENTATION_CARD: 'simple_presentation_card', // simple card with text only and border bottom
};
